import { render, staticRenderFns } from "./Honors.vue?vue&type=template&id=382b8c89&scoped=true"
import script from "./Honors.vue?vue&type=script&lang=js"
export * from "./Honors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b8c89",
  null
  
)

export default component.exports